class ApiError extends Error {
  constructor(message, status, data) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.data = data;
  }
}

class ApiService {
  constructor() {
    this.baseURL = (process.env.REACT_APP_API_URL || "https://api.oekfb.eu").replace(/\/$/, "");
  }

  getCookie(name) {
    const prefix = `${encodeURIComponent(name)}=`;
    const part = document.cookie.split("; ").find((item) => item.startsWith(prefix));
    return part ? decodeURIComponent(part.slice(prefix.length)) : null;
  }

  async request(method, endpoint, body = null, headers = {}) {
    const path = String(endpoint || "").replace(/^\/+/, "");
    const token = this.getCookie("authToken");
    const isFormData = typeof FormData !== "undefined" && body instanceof FormData;
    const requestHeaders = {
      Accept: "application/json",
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...headers,
    };

    const response = await fetch(`${this.baseURL}/${path}`, {
      method,
      headers: requestHeaders,
      credentials: "include",
      ...(body == null ? {} : { body: isFormData ? body : JSON.stringify(body) }),
    });

    const text = await response.text();
    let data = null;
    if (text) {
      try {
        data = JSON.parse(text);
      } catch {
        data = text;
      }
    }

    if (!response.ok) {
      const message =
        (data && typeof data === "object" && (data.reason || data.message)) ||
        (typeof data === "string" && data) ||
        `Request failed (${response.status})`;
      throw new ApiError(message, response.status, data);
    }

    return data;
  }

  get(endpoint, headers = {}) {
    return this.request("GET", endpoint, null, headers);
  }

  post(endpoint, body = null, headers = {}) {
    return this.request("POST", endpoint, body, headers);
  }

  put(endpoint, body = null, headers = {}) {
    return this.request("PUT", endpoint, body, headers);
  }

  patch(endpoint, body = null, headers = {}) {
    return this.request("PATCH", endpoint, body, headers);
  }

  delete(endpoint, headers = {}) {
    return this.request("DELETE", endpoint, null, headers);
  }
}

export { ApiError };
export default ApiService;
